module.exports = __webpack_public_path__ + "static/media/8793.37dd1d52.png";